import { withSelect } from '@wordpress/data'
import { decodeEntities } from '@wordpress/htmlEntities'
import { PostSelector } from '~cartzillagb/components'

let PostIDSelector = ( props ) => {
    return(
        <PostSelector { ...props }
            onPostSelect={post => {
                props.onPostSelect( post.id )
            }}
            onChange={posts => {
                let postIDS = posts.map( ( post, i ) => {
                    return post.id
                } )
                props.onChange( [...postIDS] )
            }}
        />
    )
}

export default withSelect( ( select, props ) => {
    const { posts = [], postType = 'post' } = props
    const { getEntityRecords } = select('core')

    let newPosts = posts && posts.length ? getEntityRecords( 'postType', postType, { include: posts.join(',') } ) : []

    newPosts = newPosts ? newPosts.map( ( post, i ) => {
        return {
            title: decodeEntities(post.title.rendered),
            id: post.id,
            excerpt: post.excerpt ? decodeEntities(post.excerpt.rendered) : null,
            url: post.link,
            date: post.date,
            type: post.type,
            status: post.status
        }
    } ) : []

    return {
        posts: newPosts,
    }
} )( PostIDSelector )